<div [class]="wrap() ? 'flex flex-col items-start gap-1.5' : 'flex w-max min-w-full items-center gap-2 sm:justify-end'">
  @if (periodPill(); as pill) {
    @if (expanded()) {
      <span class="text-xs font-medium text-gray-700 dark:text-gray-200" data-testid="period-pill">
        <span class="text-gray-500 dark:text-gray-400">{{ pill.label }}:</span> {{ pill.value }}
      </span>
    } @else {
      <span class="inline-flex shrink-0 items-center gap-2 rounded-full bg-blue-light-50 px-3 py-1 text-xs font-medium text-blue-light-900 dark:bg-blue-light-950 dark:text-blue-light-200"
            data-testid="period-pill">
        <span class="whitespace-nowrap"><span class="text-blue-light-700 dark:text-blue-light-400">{{ pill.label }}:</span> {{ pill.value }}</span>
      </span>
    }
  }
  @for (pill of networkPills(); track pill.key) {
    @if (expanded()) {
      <span class="text-xs font-medium text-gray-700 dark:text-gray-200" data-testid="network-pill">
        <span class="text-gray-500 dark:text-gray-400">{{ pill.label }}:</span> <span class="capitalize">{{ pill.value }}</span>
      </span>
    } @else {
      <span class="inline-flex shrink-0 items-center gap-2 rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-200"
            [class.cursor-pointer]="pill.hasMore"
            cdkOverlayOrigin
            #pillOrigin="cdkOverlayOrigin"
            data-testid="network-pill"
            (click)="pill.hasMore && togglePillDropdown(pill.key)">
        <span class="whitespace-nowrap"><span class="text-gray-500 dark:text-gray-400">{{ pill.label }}:</span> <span class="capitalize">{{ pill.displayValue }}</span></span>
      </span>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="pillOrigin"
        [cdkConnectedOverlayOpen]="openPillKey() === pill.key"
        [cdkConnectedOverlayHasBackdrop]="true"
        cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
        (overlayOutsideClick)="closePillDropdown()"
        (detach)="closePillDropdown()">
        <div class="mt-1 max-h-48 w-64 overflow-y-auto custom-scrollbar rounded-lg border border-gray-200 bg-white p-2 shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark">
          <ul class="space-y-1">
            @for (value of pill.values; track value) {
              <li class="whitespace-nowrap text-xs capitalize text-gray-700 dark:text-gray-200">{{ value }}</li>
            }
          </ul>
        </div>
      </ng-template>
    }
  }
</div>
